export default __webpack_public_path__ + "static/media/cloud-download.b70f76d9.svg";